import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EndUserLicenseAgreementListFacade } from './end-user-license-agreement-list.facade';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class EndUserLicenseAgreementListGuard {
  constructor(private eulaListFacade: EndUserLicenseAgreementListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.eulaListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.eulaListFacade);
  }
}
